/***
 * MODULES.WIDGET
 * List of modules avaiables for an account
 */

import { connect } from "react-redux"
import { WithTranslation, withTranslation } from "react-i18next"
import { Session } from "@/redux/_session.types"
import { AccountFeatures, AccountModules } from "@/redux/account.types"
import { forOwn } from "lodash"
import ListItem from "@/components/list-item"
import Checkbox from "@/components/checkbox"
import Space from "@/components/space"
import Chip from "@/components/chip"
import ListCell from "@/components/list-cell"
import ListFields from "@/components/list-fields"
import { accountEdit } from "@/redux/account.actions"
import { store } from "@/core/root-reducer"

interface StateProps extends WithTranslation {
  _session: Session
}

interface OwnProps {
  readonly?: boolean
  onSave?: Function
  modules: AccountModules
  features: AccountFeatures
}

type Props = StateProps & OwnProps

function ModulesWidget(props: Props) {
  const { t } = props
  // Get list of modules to display
  function getReadyOnly() {
    const features: { feature: string; modules: string[] }[] = []

    forOwn(props.features, (value, key) => {
      const modulesRaw = props.modules[key]

      if (modulesRaw) {
        const activeModules = Object.entries(modulesRaw)
          .filter(([, v]) => v === true)
          .map(([k]) => k)

        if (value) {
          features.push({
            feature: t("feature_" + key),
            modules: activeModules
          })
        }
      } else if (value) {
        // If feature is true but no modules
        features.push({
          feature: t("feature_" + key),
          modules: []
        })
      }
    })

    if (features.length) {
      return (
        <div>
          {features.map((f, index) => (
            <div key={index} style={{ marginBottom: "4px" }}>
              <div>{f.feature}</div>
              {f.modules.length > 0 && (
                <div className="grey-t" style={{ fontSize: "12px" }}>
                  {f.modules.map((m) => t("module_" + m)).join(", ")}
                </div>
              )}
            </div>
          ))}
        </div>
      )
    } else {
      return <span className="grey-t">{t("utils_empty")}</span>
    }
  }

  function selectModule(feature: string, module: string, value: boolean) {
    store.dispatch(
      accountEdit("modules", {
        ...props.modules,
        [feature]: {
          ...(props.modules[feature] || {}),
          [module]: value
        }
      })
    )

    save()
  }

  function selectFeature(feature: string, value: boolean) {
    store.dispatch(accountEdit("features", Object.assign({}, props.features, { [feature]: value })))
    save()
  }

  function save() {
    setTimeout(() => {
      if (props.onSave) {
        props.onSave()
      }
    }, 200)
  }

  return props.readonly ? (
    <div>{getReadyOnly()}</div>
  ) : (
    <div>
      <ListFields>
        <ListCell width={200}>Fonctionnalités</ListCell>
        <ListCell width={200}>{t("account_modules")}</ListCell>
      </ListFields>

      {Object.keys(new AccountFeatures()).map((feature) => (
        <ListItem key={feature} isSmall>
          <ListCell width={200}>
            <Checkbox
              active={props.features[feature]}
              text={t("feature_" + feature)}
              onClick={() => selectFeature(feature, !props.features[feature])}
            />
            <Space />
          </ListCell>
          {props.modules[feature] && (
            <div>
              {props.features[feature] && (
                <div className="flex1 flex flex-wrap">
                  {Object.keys(new AccountModules()[feature]).map((module) => (
                    <Chip
                      onClick={() => selectModule(feature, module, !props.modules[feature][module])}
                      isWithMargin
                      key={module}
                      color={props.modules[feature][module] ? props._session.accountColors.active : null}>
                      {t("module_" + module)}
                    </Chip>
                  ))}
                </div>
              )}
            </div>
          )}
        </ListItem>
      ))}
    </div>
  )
}

const mapStateToProps = (state) => ({
  _session: state._session
})

export default connect(mapStateToProps)(withTranslation()(ModulesWidget))
